<template>
  <div style="padding: 50px 20px; text-align: center;">
    <router-link to="/login">
      <IconCard :title="$t('index.login')" icon="lock.svg"></IconCard>
    </router-link>
    <a href="/license/buy" v-if="!fromResourcePage">
      <IconCard :title="$t('index.buyLicense')" icon="key.svg"></IconCard>
    </a>
  </div>
</template>

<script>
import IconCard from '../components/IconCard.vue';

export default {
  name: 'Index',
  components: {
    IconCard
  },
  computed: {
    fromResourcePage() {
      if (this.$route.query.o === 'res')
        window.isResourcePage = true;

      return window.isResourcePage;
    }
  }
}
</script>

<style scoped lang="scss">

</style>